export default __webpack_public_path__ + "static/media/illustration.ccba3d3c.svg";